"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const select_1 = __importDefault(require("@kyruus/select"));
const styles_1 = require("../styles");
const MultiSelectFilter = ({ column, showLabel = false, tableId, isLoading = false }) => {
    const { filterValue, setFilter, id, render, filterOptions, filterLabel } = column;
    const inputInfo = filterLabel || `Filter by ${render('Header')}`;
    const filterLabelId = `filter-select-label-${tableId}-${id}`;
    const filterId = `filter-select-${tableId}-${id}`;
    return (react_1.default.createElement("span", { role: "presentation", onClick: (e) => {
            e.stopPropagation();
        } },
        showLabel ? (react_1.default.createElement(styles_1.FilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)) : (react_1.default.createElement(styles_1.HiddenFilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)),
        react_1.default.createElement(select_1.default, { id: filterId, disabled: isLoading, itemListWidth: "auto", labelId: filterLabelId, name: filterId, "aria-labelledby": filterLabelId, placeholder: inputInfo, multiSelect: true, items: filterOptions, selectedItems: filterValue, onClear: (clearSelection) => {
                clearSelection();
            }, itemToString: (item) => item ? item.label || '' : '', inputProps: {
                ['data-testid']: 'multi-select-filter',
                onClick: (e) => {
                    e.stopPropagation();
                }
            }, onChange: (selectedItems) => {
                if (selectedItems == null || selectedItems.length === 0) {
                    setFilter([]);
                }
                else {
                    setFilter(selectedItems);
                }
            } })));
};
exports.default = MultiSelectFilter;
//# sourceMappingURL=MultiSelectFilter.js.map